import { BasePage } from '@/components/ui/base-page'

export function StrategiesPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add StrategiesPage specific content here */}
    </BasePage>
  )
}